import { useCallback, useMemo } from 'react';
import { useSetRecoilState } from 'recoil';
import { productPageOverlaySelector } from '../../recoil/atoms/product-overlay';
import { setOverlayTimerSelector } from '../../recoil/atoms/timer-overlay';



const useSecretChatMessage = () => {
  const setTimerOverlay = useSetRecoilState(setOverlayTimerSelector)
  const setProductPageOnOverlay = useSetRecoilState(productPageOverlaySelector)

  const secretMessageCallbacks = useMemo(() => {
    // We have dummy data so you will see hardcode data
    return {
      startTimerOverlayDown: () =>
        setTimerOverlay({
          action: "START",
          payload: { allowedDuration: 5 * 60 * 1000, timerDirection: 1 }
        }),
      startTimerOverlayUp: () =>
        setTimerOverlay({
          action: "START",
          payload: { allowedDuration: 5 * 60 * 1000, timerDirection: 2 }
        }),

      pauseTimerOverlay: () =>
        setTimerOverlay({ action: "PAUSE", payload: {} }),

      stopTimerOverlay: () => setTimerOverlay({ action: "STOP", payload: {} }),

      secretmodalopen: () =>
        setProductPageOnOverlay({
          url: "https://www.next.co.uk/g9531s2/m39016?utm_source=PRnational&utm_medium=online+&utm_campaign=Liveshopping_womens_juneCut-OutDetailStrappyDress&utm_id=Liveshopping_womens_juneCut-OutDetailStrappyDress#m39016"
        })
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSecretChatMessage = useCallback((message) => {
    // -> Enable experimental features using chat secret message
    const caseHandler = secretMessageCallbacks[message]
    
    if(caseHandler) {
      caseHandler()
      return true
    }

    return false
  }, [])

  return { handleSecretChatMessage }
}

export default useSecretChatMessage